var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"div"},[(_vm.isFilled)?_c('button',{staticClass:"button is-small text-button bold",on:{"click":_vm.downloadPdf}},[_vm._v("\n        "+_vm._s(_vm.car.proforma_invoice.issued_date)+"\n    ")]):_c('button',{staticClass:"button is-small text-button"},[_vm._v("\n        ---\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-166a4782","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cars/Columns/InvoiceDownloadColumn.vue
// module id = null
// module chunks = 